import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SuiviPortefeuilleRoutingModule } from './suivi-portefeuille-routing.module';
import { SharedModule } from '../shared/shared.module';
import { CompteComponent } from './compte/compte.component';
import { DetailCompteTabComponent } from './compte/detail-compte-tab/detail-compte-tab.component';
import { DossierComponent } from './dossier/dossier.component';
import { DetailDossierTabComponent } from './dossier/detail-dossier-tab/detail-dossier-tab.component';
import { EcheanceTabComponent } from './dossier/detail-dossier-tab/echeance-tab/echeance-tab.component';
import { DossierInfoTabComponent } from './dossier/detail-dossier-tab/dossier-info-tab/dossier-info-tab.component';
import { ProvisionTabComponent } from './dossier/detail-dossier-tab/provision-tab/provision-tab.component';
import { DossierTabComponent } from './compte/detail-compte-tab/dossier-tab/dossier-tab.component';
import { DossierImpayeTabComponent } from './compte/detail-compte-tab/dossier-impaye-tab/dossier-impaye-tab.component';
import { RequestTabComponent } from './compte/detail-compte-tab/request-tab/request-tab.component';
import { CompteByGestionnaireComponent } from './compte-by-gestionnaire/compte-by-gestionnaire.component';
import { DossierByGestionnaireComponent } from './dossier-by-gestionnaire/dossier-by-gestionnaire.component';
import { HistoriqueImportationComponent } from './historique-importation/historique-importation.component';
import { ProvisionsComponent } from './provisions/provisions.component';
import { DetailProvisionComponent } from './provisions/detail-provision/detail-provision.component';
import { DetailImportationComponent } from './historique-importation/detail-importation/detail-importation.component';
import { VuePortefeuilleComponent } from './vue-portefeuille/vue-portefeuille.component';
import { PortefeuilleComponent } from './vue-portefeuille/portefeuille/portefeuille.component';
import { EligibleAuDeclassementComponent } from './vue-portefeuille/eligible-au-declassement/eligible-au-declassement.component';
import { DeclasseComponent } from './vue-portefeuille/declasse/declasse.component';
import { RestructureComponent } from './vue-portefeuille/restructure/restructure.component';
import { VueStaticComponent } from './vue-portefeuille/vue-static/vue-static.component';
import { PortefeuilleTabsComponent } from './vue-portefeuille/portefeuille-tabs/portefeuille-tabs.component';
import { InfoClientComponent } from './vue-portefeuille/portefeuille-tabs/info-client/info-client.component';
import { EcheanceComponent } from './vue-portefeuille/portefeuille-tabs/echeance/echeance.component';
import { EtatCreanceComponent } from './vue-portefeuille/portefeuille-tabs/etat-creance/etat-creance.component';
import { CommiteCreditComponent } from './vue-portefeuille/eligible-au-declassement/commite-credit/commite-credit.component';


@NgModule({
  imports: [CommonModule, SuiviPortefeuilleRoutingModule, SharedModule],

  declarations: [
    CompteComponent,
    DetailCompteTabComponent,
    DossierComponent,
    DetailDossierTabComponent,
    EcheanceTabComponent,
    DossierInfoTabComponent,
    ProvisionTabComponent,
    DossierTabComponent,
    DossierImpayeTabComponent,
    RequestTabComponent,
    CompteByGestionnaireComponent,
    DossierByGestionnaireComponent,
    HistoriqueImportationComponent,
    ProvisionsComponent,
    DetailProvisionComponent,
    DetailImportationComponent,
    VuePortefeuilleComponent,
    PortefeuilleComponent,
    EligibleAuDeclassementComponent,
    DeclasseComponent,
    RestructureComponent,
    VueStaticComponent,
    PortefeuilleTabsComponent,
    EcheanceComponent,
    InfoClientComponent,
    EtatCreanceComponent,
    CommiteCreditComponent
  ],

  entryComponents: [
    DetailProvisionComponent,
    DetailImportationComponent,
    PortefeuilleTabsComponent,
    CommiteCreditComponent
  ],

  providers: []
})
export class SuiviPortefeuilleModule {}
